import React, { Component } from 'react';
import axios from 'axios';
import './auth.css';

class Auth extends Component {

    state = {
        url: window.location.href,
        title: 'Alsoug Moments',
        description: ''
    }

    constructor(props) {
        super(props);

        this.doLogin = this.doLogin.bind(this);
    }


    doLogin(ev) {
        ev.preventDefault();

        let data = new FormData();
        let inputs = this.refs.loginForm.querySelectorAll('[name]')

        if (inputs) {
            inputs.forEach(input => {
                data.append(input.name, input.value);
            })
        }

        console.log(inputs)

        axios.post('https://www.alsoug.com/login', data, {
            headers: {
                ApiKey: 'd5ab8dc7ef67ca92e41d730982c5c602'
            }
        }).then(res => {
            localStorage.setItem('token', res.data.auth_token);
            this.props.loginCallBack(true)
        })

        return false;
    }

    renderLoginForm() {
        return (
            <form className='form' onSubmit={this.doLogin} ref="loginForm">
                <label className="label">
                    <input className="input" name="email" type='text' required placeholder="اكتب رقم التليفون المسجل على السوق" />
                </label>
                <label className="label">
                    <input className="input" name="password" type='password' required placeholder="الرمز السري" />
                </label>
                <button className="button" type="submit">تسجيل دخول</button>
                <a className="register" href="https://www.alsoug.com/login">التسجيل</a>
            </form>
        )
    }

    render() {
        return (
            <div className="login">
                سجل دخولك عن طريق السوق للتعليق {this.props.id}
                {this.renderLoginForm()}
            </div>
        );
    }
}

export default Auth;
